import React from "react";
import PropTypes from "prop-types";

export default function ScrollPositionedHeader({
  className = "",
  targetId = null,
  top = 0,
  stopTargetId = null,
  stopTop = 0,
  width = "100%",
  children,
  zIndex = 1,
  style = {},
}) {
  const [visible, setVisible] = React.useState(false);

  const headerId = React.useMemo(
    () => `scroll-positioned-header-${Math.random().toString(12)}`,
    [],
  );

  React.useEffect(() => {
    const handleScroll = () => {
      if (!targetId || targetId === "") {
        console.warn(
          `ScrollPositionedHeader: targetId is not set, cannot position header.`,
        );
        return;
      }
      const header = document.getElementById(`${headerId}`);
      const target = document.getElementById(`${targetId}`);
      const stopTarget = document.getElementById(`${stopTargetId}`);
      if (header && target) {
        // get the top position of the holder in the viewport
        const rect = target.getBoundingClientRect();
        const start = rect.y <= top;
        let stop = false;
        let logMsg = `ScrollPositionedHeader: target=${targetId} top=${top}`;
        if (stopTarget) {
          stop = stopTarget.getBoundingClientRect().y <= stopTop;
          logMsg += `, stopTargetPos=${stopTarget ? stopTarget.getBoundingClientRect().y : "N/A"}`;
        }
        // console.log(`${logMsg}, start=${start}, stop=${stop}`);
        if (start && !stop) {
          setVisible(true);
          // header.className = `scroll-positioned-header w3-show ${className}`;
          // header.style.position = "fixed";
        } else {
          setVisible(false);
          // header.className = `scroll-positioned-header w3-hide ${className}`;
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [visible, headerId, targetId, top, className]);

  return (
    <div
      id={headerId}
      className={`scroll-positioned-header ${className}`}
      style={{
        zIndex,
        ...style,
        position: "fixed",
        top,
        width,
      }}
    >
      {visible ? children : null}
    </div>
  );
}

ScrollPositionedHeader.propTypes = {
  targetId: PropTypes.string.isRequired,
  top: PropTypes.number,
  stopTargetId: PropTypes.string,
  stopTop: PropTypes.number,
  className: PropTypes.string,
  width: PropTypes.string,
  children: PropTypes.node.isRequired,
  zIndex: PropTypes.number,
  style: PropTypes.object,
};

export function AppearOnScrollPosition({ targetId = null, top = 0, children }) {
  const [className, setClassName] = React.useState("w3-hide");

  React.useEffect(() => {
    const handleScroll = () => {
      if (!targetId || targetId === "") {
        console.warn(`AppearOnScrollPosition: targetId is not set.`);
        return;
      }
      const target = document.getElementById(`${targetId}`);
      if (target) {
        // get the top position of the holder in the viewport
        const rect = target.getBoundingClientRect();
        if (rect.y <= top) {
          setClassName(`w3-show`);
        } else {
          setClassName(`w3-hide`);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [targetId, top, className]);

  return (
    <div style={{ position: "relative", height: "0px" }}>
      <div
        className={className}
        style={{ position: "absolute", bottom: "-1px", width: "100%" }}
      >
        {children}
      </div>
    </div>
  );
}

AppearOnScrollPosition.propTypes = {
  targetId: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};
